import React from 'react';
import Image from 'gatsby-image';

import '../../sass/components/_section.scss';

const ExperienceSection = (props) => (
  <div className="experienceSection section">
    <Image alt={props.title} className="image round" outerWrapperClassName="image" resolutions={props.roundImage.childImageSharp.resolutions} />
    <div className="text">
      <h2>{props.title}</h2>
      <div>
        <div>{props.children}</div>
        {props.CTA && props.CTA}
      </div>
    </div>
    {props.fullImage && <Image outerWrapperClassName="image full" sizes={props.fullImage.childImageSharp.sizes} />}
  </div>
);

export default ExperienceSection;


// WEBPACK FOOTER //
// ./src/components/ExperienceSection.js